
import { Component, Vue } from 'vue-property-decorator';
import OverviewMenu from '../../components/navigation/OverviewMenu.vue';
@Component({
    components: {
        OverviewMenu
    }
})
export default class Overview extends Vue {}
